import cleanAuthData from './cleanAuthData';
export default (function (accountsUrl) {
  var redirectPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  cleanAuthData();
  window.location.replace("".concat(accountsUrl, "/logout?redirect=").concat(window.location.origin).concat(redirectPath));
});